<template>
  <v-form ref="form" @submit.prevent="$v.$invalid ? null : save()">
    <v-card class="pa-5" flat>
      <v-card-text>
        <AlertMessage />
        <v-row v-show="form.isBusiness">
          <v-col>
            <div class="font-weight-bold">Company</div>
            <v-text-field
              v-model="form.companyName"
              solo
              :disabled="!isEditable"
              :hide-details="
                [].concat(fieldErrors('form.companyName')).length === 0
              "
              :error-messages="[].concat(fieldErrors('form.companyName'))"
              @blur="$v.form.companyName.$touch()"
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <br />
            <h3><v-icon>portrait</v-icon> Primary Contact</h3>
            <hr />
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <div class="font-weight-bold">Email</div>

            <v-text-field
              v-model="form.email"
              solo
              :disabled="!isEditable"
              :hide-details="[].concat(fieldErrors('form.email')).length === 0"
              :error-messages="[].concat(fieldErrors('form.email'))"
              @blur="$v.form.email.$touch()"
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <div class="font-weight-bold">Phone Number</div>
            <v-text-field
              v-model="form.phoneNumber"
              :disabled="!isEditable"
              solo
              hide-details
              v-mask="`(###) ###-####`"
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" lg="6" md="6" sm="6">
            <div class="font-weight-bold">First Name</div>
            <v-text-field
              v-model="form.firstName"
              :disabled="!isEditable"
              solo
              :hide-details="
                [].concat(fieldErrors('form.firstName')).length === 0
              "
              :error-messages="[].concat(fieldErrors('form.firstName'))"
              @blur="$v.form.firstName.$touch()"
            />
          </v-col>
          <v-col cols="12" lg="6" md="6" sm="6">
            <div class="font-weight-bold">Last Name</div>

            <v-text-field
              v-model="form.lastName"
              :disabled="!isEditable"
              solo
              :hide-details="
                [].concat(fieldErrors('form.lastName')).length === 0
              "
              :error-messages="[].concat(fieldErrors('form.lastName'))"
              @blur="$v.form.lastName.$touch()"
            />
          </v-col>
        </v-row>

        <!-- <v-row>
          <v-col>
            <h3><v-icon>info_outline</v-icon> Company Info</h3>
            <hr />
          </v-col>
        </v-row> -->
        <v-row>
          <v-col>
            <v-switch
              v-model="form.isBusiness"
              label="Business Account"
              :disabled="!isEditable"
              class="shrink mr-0 mt-0"
              dense
            ></v-switch>
          </v-col>

          <v-col>
            <v-switch
              v-model="form.isPotentialClient"
              label="Potential Client"
              :disabled="!isEditable"
              class="shrink mr-0 mt-0"
              dense
            ></v-switch>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <br />
            <h3><v-icon>place</v-icon> Company Address</h3>
            <hr />
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <div class="font-weight-bold">Address</div>

            <v-text-field
              v-model="form.address"
              :disabled="!isEditable"
              solo
              :hide-details="
                [].concat(fieldErrors('form.address')).length === 0
              "
              :error-messages="[].concat(fieldErrors('form.address'))"
              @blur="$v.form.address.$touch()"
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <div class="font-weight-bold">City</div>
            <v-text-field
              v-model="form.city"
              solo
              :disabled="!isEditable"
              :hide-details="[].concat(fieldErrors('form.city')).length === 0"
              :error-messages="[].concat(fieldErrors('form.city'))"
              @blur="$v.form.city.$touch()"
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" lg="6" md="6" sm="6">
            <div class="font-weight-bold">State</div>
            <state-select
              v-model="form.state"
              solo
              :disabled="!isEditable"
              :hide-details="[].concat(fieldErrors('form.state')).length === 0"
              :error-messages="[].concat(fieldErrors('form.state'))"
              @blur="$v.form.state.$touch()"
            />
          </v-col>
          <v-col cols="12" lg="6" md="6" sm="6">
            <div class="font-weight-bold">Zipcode</div>

            <v-text-field
              v-model="form.zipcode"
              solo
              :disabled="!isEditable"
              :hide-details="
                [].concat(fieldErrors('form.zipcode')).length === 0
              "
              :error-messages="[].concat(fieldErrors('form.zipcode'))"
              @blur="$v.form.zipcode.$touch()"
            />
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions v-show="isEditable">
        <v-spacer />
        <v-btn @click="cancel()" class="mr-1">Cancel</v-btn>
        <v-btn
          type="submit"
          :disabled="$v.$invalid"
          color="info"
          :loading="loading"
          >Save</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { email, helpers } from "vuelidate/lib/validators";
import validationMixin from "@/mixins/validationMixin";
import StateSelect from "components/StateSelect.vue";
import AlertMessage from "src/components/AlertMessage";

const validZip = (value) => /^\d{5}(?:[-\s]\d{4})?$/.test(value);
const optionalOrValidZip = (value) => !helpers.req(value) || validZip(value);

// function companyNameRequiredIf(value) {
//   if (!this.form.isBusiness) {
//     return true;
//     // return !helpers.req(value);
//   } else {
//     return value.toString().length > 0;
//   }
// }

export default {
  components: {
    StateSelect,
    AlertMessage,
  },
  props: {
    clientId: [Number, String],
    mode: String,
  },

  data: () => ({
    namespace: "Client Info",
    page: "Client Info",
    usage: "usage",
    tab: null,
    editMode: false,
    addMode: false,
    loading: false,
    form: {
      isBusiness: true,
      companyName: "",
      firstName: "",
      lastName: "",
      email: "",
      state: "",
      city: "",
      address: "",
      zipcode: "",
    },
  }),

  mixins: [validationMixin],
  validations: {
    form: {
      companyName: {
        
      },
      firstName: {},
      lastName: {},
      email: {
        email,
      },
      state: {},
      city: {},
      address: {},
      zipcode: {
        optionalOrValidZip,
      },
    },
  },

  validationMessages: {
    form: {
      companyName: {
        required: "Company required",
        companyNameRequiredIf: "Company required for Business Account",
      },
      firstName: {
        required: "First name required",
      },
      lastName: {
        required: "Last name required",
      },
      address: {
        required: "Address is required",
      },
      city: {
        required: "City is required",
      },
      state: {
        required: "State is required",
      },
      email: {
        required: "Email is required",
        email: "Email format is invalid",
      },
      zipcode: {
        required: "Zipcode is required",
        validZip: "Zipcode invalid",
        optionalOrValidZip: "Zipcode invalid",
      },
    },
  },

  async mounted() {
    if (this.clientId) {
      await this.getById(this.clientId);
    } else {
      this.addMode = true;
    }
  },

  computed: {
    ...mapState({
      client: (state) => state.client,
    }),

    clientDetail() {
      return this.client.single;
    },

    isEdit() {
      return this.clientId && this.mode === "edit" ? true : false;
    },

    isEditable() {
      return (this.mode === "edit" && this.clientId) || this.mode === "add";
    },
  },

  watch: {
    clientDetail(n) {
      this.form = n;
    },
  },
  methods: {
    ...mapActions("client", ["create", "update", "getById"]),

    async refresh() {
      await this.getById(this.$route.params.id);
    },

    async cancel() {
      if (this.clientId) {
        this.$router.push(`/clients/${this.clientId}`);
      } else {
        this.back();
      }
    },

    async save() {
      let payload = {
        ...this.form,
      };

      if (!this.form.isBusiness) {
        payload['companyName'] = this.form.firstName + ' ' + this.form.lastName;
      }

      this.loading = true;
      if (this.isEdit) {
        await this.update(payload);
        if (!this.client.status.error) {
          this.$router.push(`/clients/${this.clientId}`);
        }
      } else {
        await this.create(payload);
        if (!this.client.status.error) {
          this.$router.push(`/clients/${this.client.single.id}`);
        }
      }
      this.loading = false;
    },

    back() {
      this.$router.push("/clients");
    },
  },
};
</script>
